<template>
  <div id="main-content">
    <h1>Legal</h1>

    <div class="row aligned">
      <div class="col-8">
        <div v-for="(policy, index) in policies" :key="index">
          <Accordion :accBtn="policy.header">
            <h2>{{ policy.header }}</h2>
            <div v-html="policy.content"></div>
          </Accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Accordion } from '@/components';
import axios from 'axios';

export default {
  name: 'legal',
  components: {
    Accordion,
  },
  data() {
    return {
      policies: [],
    };
  },
  mounted() {
    axios
      .get('/api/termsandconditions')
      .then((response) => {
        this.policies = response.data.data;
      })
      .catch((error) => {
        this.policies = {
          header: 'Error',
          content: '<p>Unfortunately something has gone wrong with retreiving the content for this page. Please refresh your browser and try again.</p>',
        };
        logger.error(error);
      });
  },
};
</script>
